import { render, staticRenderFns } from "./apkSend.vue?vue&type=template&id=56d3325c&scoped=true"
import script from "./apkSend.vue?vue&type=script&lang=js"
export * from "./apkSend.vue?vue&type=script&lang=js"
import style0 from "./apkSend.vue?vue&type=style&index=0&id=56d3325c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d3325c",
  null
  
)

export default component.exports